import { get, post } from '@/utils/http'
import type {
  IReqCreatePayment,
  IReqQueryPaymentStatus,
  IResCreatePayment,
  IResMembershipPlans,
  IResPointRechargePackages,
  IResQueryPaymentStatus,
  IResUserMembershipDetail,
} from '@/types/apis/membership'

// 会员套餐信息
export const apiGetMembershipPlans = () => post<IResMembershipPlans>('/UserClip/AILionDrama/GetMembershipPlans')

// 积分充值套餐信息
export const apiGetPointRechargePackages = () =>
  get<IResPointRechargePackages>('/UserClip/AILionDrama/GetPointRechargePackages')

// 创建支付订单
export const apiCreatePayment = (payload: IReqCreatePayment) =>
  post<IResCreatePayment>('/UserClip/AILionDrama/CreatePayment', payload)

// 查询支付状态
export const apiQueryPaymentStatus = (payload: IReqQueryPaymentStatus) =>
  post<IResQueryPaymentStatus>('/UserClip/AILionDrama/QueryPaymentStatus', payload)

// 查询用户会员信息
export const apiGetUserMembershipDetail = () =>
  post<IResUserMembershipDetail>('/UserClip/AILionDrama/GetUserMembershipDetail')
